import { PaginationData } from 'src/shared/types/paginationData.interface';

export const DefaultPagination: PaginationData = {
  currentIndex: 1,
  sizePerPage: 10,
  searchValue: '',
  sortOrder:'asc',
  columnName: 'memberId'
};
